import { useNavigate } from '@tanstack/react-router';
import { UserListTable } from '../components/UserListTable';
import {
  USER_TYPE_GROUPS,
  USER_CATEGORY_TITLES,
  type UserTypeGroup,
} from '../constants/user.constants';

export function UserCategoryPage({ category }: { category: UserTypeGroup }) {
  const navigate = useNavigate();
  return (
    <UserListTable
      title={USER_CATEGORY_TITLES[category]}
      userTypeIds={USER_TYPE_GROUPS[category]}
      category={category}
      onCreateClick={() => navigate({ to: '/users/create/$category', params: { category } })}
    />
  );
}
